import { useMetadadosObter } from '@hooks/EstruturaPost/useMetadadosObter';
import { createContext, useCallback, useEffect, useState } from '@wordpress/element';
import { POST_ID } from '../../../routes/Variables';
import { useMetadadosNotas } from '@hooks/EstruturaPost/Metadados/useMetadadosNotas';
import { montarSlug } from '@hooks/UtilHooks';
import { useActionParam } from '@api/actions/action';

const EstruturaPostContext = createContext({
  obterMetadados: () => {},
  alterarConteudoEstrutura: () => {},
  metadados: null,
  estrutura: {
    palavra_chave: '',
    title_seo: '',
    slug: '',
    link_permanente: '',
    meta_descricao: '',
    alt_imagem: '',
    autor: '',
    pre_visualizacao: '',
    breadcrumbs: '',
  },
  carregando: false,
  erro: null,
});

export function EstruturaPostProvider({ children }) {
  const [estrutura, setEstrutura] = useState({
    palavra_chave: '',
    title_seo: '',
    slug: '',
    link_permanente: '',
    meta_descricao: '',
    alt_imagem: '',
    autor: '',
    breadcrumbs: '',
  });
  const [carregando, setCarregando] = useState(false);

  const { mutateAsync } = useActionParam();

  const { obterMetadados, metadados, erro } = useMetadadosObter({
    idPost: POST_ID,
    executarAutomaticamente: false,
  });

  const atualizarMetadados = useCallback((metadado, conteudo, atualizar = true) => {
    setCarregando(true);
    mutateAsync({
      action: 'alterar_dados_post_meta',
      param: {
        post_id: parseInt(POST_ID),
        meta_key: metadado,
        meta_value: conteudo,
      },
    })
      .then((res) => {
        console.log('Metadados atualizados:', res);
        if (atualizar) obterMetadados();
      })
      .finally(() => setCarregando(false));
  }, []);

  const { notas } = useMetadadosNotas({ metadados });

  const alterarConteudoEstrutura = useCallback((metadado, conteudo) => {
    setEstrutura(prev => {
      const estadoAtualizado = {
        ...prev,
        [metadado]: {
          ...prev[metadado],
          conteudo: metadado === 'slug' ? { valor: conteudo, existe: false } : conteudo,
        },
      };

      if (metadado === 'title_seo') {
        atualizarMetadados('_opti_seo_title_seo', conteudo);
      }

      if (metadado === 'slug') {
        atualizarMetadados('_opti_seo_slug', conteudo);
      }

      if (metadado === 'meta_descricao') {
        atualizarMetadados('_opti_seo_metadesc', conteudo);
      }

      if (metadado === 'alt_imagem') {
        atualizarMetadados('_opti_seo_alt_imagem', conteudo);
        const intervalId = setInterval(() => {
          let item = document.getElementsByClassName('editor-post-featured-image__action');
          let itemFoto = document.getElementsByClassName('editor-post-featured-image__container');
          if (item && item.item(0)) {
            document
              .querySelectorAll('.alt-text #attachment-details-alt-text')
              .forEach(function (item) {
                item.value = conteudo;
              });
            clearInterval(intervalId);
          }
        }, 1000);

        
      }

      if (metadado === 'palavra_chave') {
        const tituloAtual = prev.title_seo.conteudo;
        let novoConteudo = '';
        if (!tituloAtual || tituloAtual === '') {
          novoConteudo = conteudo;
        } else {
          const separadorIndex = tituloAtual.indexOf(':');
          novoConteudo =
            separadorIndex >= 0
              ? `${conteudo}${tituloAtual.substring(separadorIndex)}`
              : tituloAtual;
        }
        estadoAtualizado.title_seo = {
          ...prev.title_seo,
          conteudo: novoConteudo,
        };

        const novoSlug = montarSlug(conteudo);
        estadoAtualizado.slug = {
          ...prev.slug,
          conteudo: {
            existe: true,
            valor: novoSlug,
          },
        };

        Promise.all([
          atualizarMetadados('_opti_seo_title_seo', novoConteudo, false),
          atualizarMetadados('_opti_seo_focuskw', conteudo, false),
          atualizarMetadados('_opti_seo_slug', novoSlug, false),
        ]).then(() => {
          obterMetadados();
        });
      }
      return estadoAtualizado;
    });
  }, []);

  function gerarObjeto(metadado, metadados, notas) {
    return {
      conteudo: metadados[metadado],
      criterios: notas[metadado].criterios,
      valor: notas[metadado].valor,
    };
  }

  useEffect(() => {
    setCarregando(true);
    if (notas.palavra_chave.criterios.length > 0) {
      setEstrutura({
        palavra_chave: gerarObjeto('palavra_chave', metadados, notas),
        title_seo: gerarObjeto('title_seo', metadados, notas),
        slug: gerarObjeto('slug', metadados, notas),
        link_permanente: gerarObjeto('link_permanente', metadados, notas),
        meta_descricao: gerarObjeto('meta_descricao', metadados, notas),
        alt_imagem: gerarObjeto('alt_imagem', metadados, notas),
        autor: gerarObjeto('autor', metadados, notas),
        pre_visualizacao: gerarObjeto('pre_visualizacao', metadados, notas),
        breadcrumbs: gerarObjeto('breadcrumbs', metadados, notas),
      });

      setCarregando(false);
    }
  }, [notas]);

  const value = {
    obterMetadados,
    alterarConteudoEstrutura,
    metadados,
    estrutura,
    carregando,
    erro,
  };
  return <EstruturaPostContext.Provider value={value}>{children}</EstruturaPostContext.Provider>;
}

export default EstruturaPostContext;
